import * as yup from 'yup';
import { VALIDATION_MESSAGE } from '../constants/Constants';
const emojiFreeRegex = /^[\w\s\.,'!&@()-]+$/;



const RegisterValidation: any = yup.object().shape({
    name: yup.string().required(VALIDATION_MESSAGE.Field("name"))
        .min(3, VALIDATION_MESSAGE?.MinLength("name ", 3))
        .max(25, VALIDATION_MESSAGE?.MaxLength(" name", 25))
        .matches(emojiFreeRegex, ("Emojis not allowed")),

    email: yup.string().required(VALIDATION_MESSAGE.Field("email"))
        .email(VALIDATION_MESSAGE.EMAIL_ADDRESS)
        .matches(VALIDATION_MESSAGE.EMAIL_REGREX, VALIDATION_MESSAGE.EMAIL_ADDRESS)
        .max(150, VALIDATION_MESSAGE.MaxLength('Email', 150))
        .trim(),
    // phone_number: yup.string()
    //     .optional()
    //     .min(7, VALIDATION_MESSAGE.PHONE_NUMBER_VALID)
    //     .max(15, VALIDATION_MESSAGE.PHONE_MAX_CHAR)
    //     .matches(/^[0-9]*$/, VALIDATION_MESSAGE.VALID_PHONE_NUMBER) // Allow only digits
    //     .test('valid-phone', VALIDATION_MESSAGE.VALID_PHONE, value => {
    //         if (!value) return true; // Return true if value is not provided (handled by required validation)
    //         if (/^0+$/.test(value)) {
    //             return false; // Reject if all characters are '0'
    //         }

    //         return true;
    //     }),
    phone_number: yup.string()
    .optional() 
    .test('phone-required', VALIDATION_MESSAGE.VALID_PHONE, (value:any) => {
        if (value && value.trim().length > 0) {
            return yup.string()
                .min(7, VALIDATION_MESSAGE.PHONE_NUMBER_VALID)  
                .max(15, VALIDATION_MESSAGE.PHONE_MAX_CHAR) 
                .matches(/^[0-9]*$/, VALIDATION_MESSAGE.VALID_PHONE_NUMBER) // Only digits allowed
                .test('valid-phone', VALIDATION_MESSAGE.VALID_PHONE, (value:any) => {
                    if (/^0+$/.test(value)) {
                        return false;
                    }
                    return true;
                })
                .isValidSync(value); // Validate synchronously
        }
        return true; // Return true if no phone number is entered (no error)
    }),

    password: yup.string().required(VALIDATION_MESSAGE.Field("password"))
        .min(8, VALIDATION_MESSAGE?.MinLength('Password', 8))
        .max(15, VALIDATION_MESSAGE?.MaxLength('Password', 15))
        .matches(/^\S*$/, VALIDATION_MESSAGE?.NO_SPACE_ALLOWED)
        .matches(/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[`~`!@#$%^&.,<>?/*:";'{}()=\[\]+_\-])[A-Za-z\d~`!@#$%^&.,<>?/*:";'{}()\[\]=+_\-]{8,15}$/, VALIDATION_MESSAGE?.PASSWORD_UPPER_CASE),

    confirm_password: yup.string().required(VALIDATION_MESSAGE.Field("confirm password"))
        .min(8, VALIDATION_MESSAGE?.MinLength('Confirm password', 8))
        .max(15, VALIDATION_MESSAGE?.MaxLength('Confirm password', 15))
        .oneOf([yup.ref('password')], VALIDATION_MESSAGE?.PASSWORD_CPWD_NOT_MATCHED),

    agree: yup.boolean().required(VALIDATION_MESSAGE?.TERMS)
        .oneOf([true], VALIDATION_MESSAGE?.TERMS),

    phone_country_code: yup.string().required(VALIDATION_MESSAGE.Field("country code"))

});

export default RegisterValidation;

